import './App.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import Home from './Pages/Home';
import Aboutus from './Pages/Aboutus';
import Services from './Pages/Services';
import Solutions from './Pages/Solutions';
import Careers from './Pages/Careers';
import Contact from './Pages/Contact';
import SelectSignupType from './Pages/SelectSignupType';
import EmployerSignUpCompanyDetails from './Pages/EmployerSignUpCompanyDetails';
import EmployerSignUpIndustryFocus from './Pages/EmployerSignUpIndustryFocus';
import EmployerSignUpContactPersonDetails from './Pages/EmployerSignUpContactPersonDetails';
import EmployerSignUpAccountSecurity from './Pages/EmployerSignUpAccountSecurity';
import EmployerSignUpPreviewandSubmit from './Pages/EmployerSignUpPreviewandSubmit';
import Mainheader from './Components/Mainheader';
import Footer from './Components/Footer';


const App = () => { 
  return (
     <div className="App">
      <BrowserRouter>
      <Mainheader/>          
      <Switch>        
      <Route path="/" exact component={Home}/> 
       <Route path="/Aboutus"  exact component={Aboutus}/>   
       <Route path="/Services"  exact component={Services}/>    
       <Route path="/Solutions"  exact component={Solutions}/>    
       <Route path="/Careers"  exact component={Careers}/>     
       <Route path="/Contact"  exact component={Contact}/>   
       <Route path="/SelectSignupType"  exact component={SelectSignupType}/> 
       <Route path="/EmployerSignUpCompanyDetails"  exact component={EmployerSignUpCompanyDetails}/>   
       <Route path="/EmployerSignUpIndustryFocus"  exact component={EmployerSignUpIndustryFocus}/>        
       <Route path="/EmployerSignUpContactPersonDetails"  exact component={EmployerSignUpContactPersonDetails}/>    
       <Route path="/EmployerSignUpAccountSecurity"  exact component={EmployerSignUpAccountSecurity}/>   
       <Route path="/EmployerSignUpPreviewandSubmit"  exact component={EmployerSignUpPreviewandSubmit}/>     
       <Route path="/Mainheader"  exact component={Mainheader}/>  
       <Route path="/Footer"  exact component={Footer}/>  
       </Switch>
       <Footer/>
       </BrowserRouter>
       </div>
  );
}
export default App;